import { IconProps } from 'almanac-ui/icons/Types'
import Styles from './FolderFilledIcon.module.scss'
import FolderFilled from 'blaze-ui/icons/20/FolderFilled'

interface Props extends IconProps {}

export const FolderFilledIcon = ({ size = 16 }: Props) => {
  return (
    <div className={Styles.container} style={{ height: size, width: size }}>
      <FolderFilled color="var(--selected-stroke)" size={size - 4} />
    </div>
  )
}
